export const addAircraftCode = ({ form, store }) => {
    form.setConfig({
        "title": "Add Aircraft Code",
        "type": "push",
        "location": "Database/AircraftCodes",
        "fields": [{
            "label": "Number",
            "type": "value",
            value() {
                return store?.state?.counts?.database?.ac?.count
            }
        }, {
            "label": "Name",
            "name": "Name",
            "type": "text"
        }, {
            "label": "Acronym",
            "name": "NameShort",
            "type": "text"
        }, {
            "label": "Type",
            "name": "Type",
            "type": "dropdown",
            "dropdownData": [{
                "label": "Aeroplane",
                "id": "Aeroplane"
            }, {
                "label": "Rotocraft",
                "id": "Rotocraft"
            }]
        }],
        async preSubmitHook({ liveInputData, db }) {
            const number = await db.utils.allocateCount("counts/database/ac/count");
            return {
                "Number": number,
                "NameFull": `${number} - ${liveInputData.Name}`
            }
        }
    });
    form.getDropdownData();
    form.toggle();
}

export const editAircraftCode = ({ form, router, rowItem }) => {
    form.setValues({ ...rowItem });
    form.setConfig({
        "title": "Edit Aircraft Code",
        "type": "update",
        "location": `Database/AircraftCodes/${rowItem.ID}`,
        "fields": [{
            "label": "Number",
            "name": "Number",
            "type": "text"
        }, {
            "label": "Name",
            "name": "Name",
            "type": "text"  
        }, {
            "label": "Acronym",
            "name": "NameShort",
            "type": "text"
        }, {
            "label": "Type",
            "name": "Type",
            "type": "dropdown",
            "dropdownData": [{  
                "label": "Aeroplane",
                "id": "Aeroplane"
            }, {
                "label": "Rotocraft",
                "id": "Rotocraft"
            }]
        }]  
    });
    form.getDropdownData();
    form.toggle();
}   
